import { Component,  OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {  
  SharedDataService, 
  SuppliersService,
  DocumentsService, 
  ContactsService}  from '../../../all-services';

import {  
  Address,
  Agency,
  Contact,
  Supplier,
  Family, 
  SupplierAnswer,
  SimpleReponseResult}  from '../../../all-models';

  
import { SupplierDetailsStepBase, checkValidityEvent } from '../supplier-details/suppliers-details-step-base';
import { SaveStepParam } from '../supplier-details/SaveStepParam';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-supplier-recap',
  templateUrl: './supplier-recap.component.html',
  styleUrls: ['./supplier-recap.component.scss']
})
export class SupplierRecapComponent extends SupplierDetailsStepBase implements OnInit, OnChanges {

  lstFamilies : Family[]=[];
  constructor(
    public sharedDatasSvc: SharedDataService,
    public suppliersSvc: SuppliersService,
    public docsSvc : DocumentsService,
    public route: ActivatedRoute,
    public contactsSvc:ContactsService) {
    super(sharedDatasSvc,docsSvc, suppliersSvc, route,contactsSvc);
  }
  
  ngOnInit(): void {
    this.sharedDatasSvc.listsSvc.getFamilies()
    .subscribe((res:Family[])=> this.lstFamilies=res);
    this.screenValidity.isValid = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['ocurrentstep']){
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean=>{ return this._ShowSaveButton()};
     }, 0);
    }
  }
  private _ShowSaveButton = ():any =>  {
    return false;
  }

  get supplierAnswers(): SupplierAnswer[]{
    return this.supplier.SupplierAnswers.filter(a=>a.Answer!=null);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }


  get contactReferentDisplayedMail():string{
    if (!this.contactReferent) return '';
    return (this.contactReferent.EmailDiff||this.contactReferent.Email)
  }

  
  save(param: SaveStepParam): void {
    if (param.nextAction == 'forceScreen') {
      super.save(param);
      return;
    }
    setTimeout(() => {
      let patchParam: Supplier=new Supplier();
      patchParam.Id=this.supplier.Id;
      patchParam.HtmlRecap = document.getElementById('recapitulatif').innerHTML; 
      this.suppliersSvc.PatchSimpleValues(this.supplier.Id,patchParam)
      .subscribe((res:SimpleReponseResult)=>{
        super.save(param);
      });
  }); 
  }

  displayAddressSupplier():String{
    let addr:Address = this.supplier.SupplierAgencies
    .find(a=>a.IsSupplierAgency==1)?.Agency?.Address;
    return this.displayAddress(addr);

  }

  displayAddressAffacturage():String{
    let addr:Address = this.supplier.FacAddress;
    return this.displayAddress(addr);

  }

  onCheckValidity(event:checkValidityEvent):Observable<boolean | undefined>{
    if (event.stepNum!=this.screenValidity.step) return of(undefined); 
    return of(true);
  }


  displayAddress(addr:Address): String{
  var ret:String= "";
    ['AddrNum','Addr1','Addr2','Addr3','Addr4','PostalCod','City']
    .forEach((prop:string)=>{
      if (prop=='PostalCod') ret +=' ';
      ret = (ret + ' ' + ((<any>addr)[prop]||'')).trim();
    });
    if (addr.Country)  ret += ' ' +  addr.Country.LblCod;
    return ret;
  }


  get contactReferent(): Contact{
    return this.supplier?.SupplierContacts.find(sc=>sc.IsReferent==1).Contact;
  }


  get otherContacts(): Contact[]{
    return this.supplier?.SupplierContacts.filter(sc=>sc.IsReferent!=1)
    .map(sc=> sc.Contact);
  }

  public get otherAgencies(): Agency[] {
    if (!this.supplier || !this.supplier.SupplierAgencies) return [];
    return this.supplier.SupplierAgencies.filter(sag => sag.IsSupplierAgency == 0).map(sag => sag.Agency);
  }

  familyLevel(familyId:number): number{
    let node : Family= this.lstFamilies.find(f=>f.Id==familyId);
    if (!node || node.ParentId== null){
      return 0;
    } else {
      return 1 + this.familyLevel(node.ParentId);
    }
  }
  familyNodeLabel(familyId: number): string {
    let node : Family= this.lstFamilies.find(f=>f.Id==familyId);
    if (!node) return '';
    switch (this.familyLevel(familyId)) {
      case 1: {
        return node.FamilyCod;
      }
      case 2: {
        return node.SubFamilyCod;
      }
      default:
        return node.Segment;
    }
  }

  mainFamilyLabel():string{
    return this.familyNodeLabel(this.supplier.SupplierFamilies.find(sf=>sf.MainFamily==1)?.FamilyId);
  }
}

